const Key = 'locale'
import cookies from 'js-cookie'
const keyCookie = 'i18next'
export function getLocale() {
  // return Cookies.get(TokenKey)
  return localStorage.getItem(Key)
}

export function setLocale(data) {
  // return Cookies.set(TokenKey, token, { expires: 365 })

  return localStorage.setItem(Key, data)
}
export function setCookieI18n(data) {
  return cookies.set(keyCookie, data)
}
